<template>
    <div class="content">
        <div class="container-fluid">

            <!-- NAVBAR -->
            <div class="row  mb-2">
                <div class="col-md-12">
                    <div class="nav-bar box-horizontal">
                      <!-- <i class="material-icons d-block text-secondary mr-2 pointer p-2" @click="$router.go(-1)">arrow_back</i> -->
                      <div class="flex-1">
                        <h3 class="m-0 text-info"><strong>Cek PPPOE</strong></h3>
                        <p class="m-0">Fitur ini digunakan untuk melihat apakah Secret di PPOE sudah terinput/tersingkron semua ke pelanggan. Jika CUSTOM akan muncul Total Pelanggan</p>
                      </div>
                    </div>
                </div>
            </div>
            <!-- NAVBAR END -->

            <div class="row">
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="card m-0 card-stats">
                        <div class="card-header card-header-success card-header-icon text-left">
                            <p class="mb-1 text-dark mt-2">Pilih Mikrotik</p>
                            <select class="form-control" id="exampleFormControlSelect1" placeholder="Pilih Resto..."  v-model="data.mikrotikPilih" v-on:change="theGet.mikrotikchange()">
                                <option value="" selected disabled>Pilih Mikrotik</option>
                                <option v-for="(u, index) in data.mikrotik" :value="u" >{{u.nama}}</option>
                            </select>

                            <p class="card-category mt-2">Total PPOE</p>

                            <h3 class="card-title text-success">{{data.MaxPPOE}}</h3>

                            <div class="d-block text-center">
                                <button class="btn btn-info mb-2" @click="theGet.getDataMikrotik(); data.MPpoeBtn = false;  data.MPpoeLoading = true" v-show="data.MPpoeBtn">Ambil PPOE Dulu</button>
                            </div>

                            <span class="text-secondary" v-show="data.MPpoeLoading">Tunggu sebentar, mungkin agak lama hehe</span>

                        </div>
                    </div>
                </div>
                <div class="col-lg-3 col-md-6 col-sm-6">
                    <div class="card m-0 card-stats">
                        <div class="card-header card-header-success card-header-icon text-left">
                            <p class="card-category mt-2">Total Pelanggan</p>
                            <h3 class="card-title text-success">{{data.MaxPelanggan}}</h3>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-show="data.MaxPPOE != 0">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <button class="btn btn-primary" v-show="data.BtnStart" @click="data.BtnStart = false; theGet.mulaiSekarang()">Mulai Sekarang</button>
                            <span class="text-info" v-show="data.TextProses">{{data.TextProsese}}</span>
                            <div class="table-responsive">
                                <table class="table">
                                    <thead class="text-info">
                                    <th width="40px">No.</th>
                                    <th>Ppoe</th>
                                    <th>Profil</th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(u, index) in data.unmatchItem">
                                            <td>{{ index+1 }}</td>
                                            <td>{{ u.name }}</td>
                                            <td>{{ u.profile }}</td>
                                        </tr>
                                        <tr v-if="data.unmatchItem == null">
                                            <td></td>
                                            <td>Tidak ada Data </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>

        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'

import { url,homePage } from '@/var/var.js'
import VueBarcode from 'vue-barcode';

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(moment)

export default {
    name: 'Beranda',
    components: { 

    }, 
    setup() {
        const data = reactive({
            filtered: '',
            
			mikrotik: [],
            mikrotikPilih: '',

            AllPelanggan: [],
            StartPelanggan: 0,
            MaxPelanggan: 0,

            MPpoeBtn: true,
            MPpoeLoading: false,
            AllPPOE: [],
            StartPPOE: 0,
            MaxPPOE: 0,

            BtnStart: true,
            TextProses: false,
            TextProsese: "",

            matchItem: [],
            unmatchItem: []
        })

        const theGet = {
            datax: reactive({
                List: [],
            }),
            mulaiSekarang() {
                if(data.MaxPelanggan == 0) {
                    alert("Pelanggan Kosong");
                    return;
                }
                if(data.MaxPPOE == 0) {
                    alert("PPoe Kosong");
                    return;
                }

                data.BtnStart = false;
                data.TextProses = true;
                // data.TextProsese = true;
                
                this.LoopPpoe();
            },
            LoopPpoe() {

                if(data.StartPPOE < data.MaxPPOE) {

                    var cd = data.AllPPOE[data.StartPPOE];
                    
                    let PPOEnama = cd.name;
                    let PPOEProfil = cd.profile;

                    // console.log(PPOEnama + " ==========================================================================");
                    
                    data.TextProsese = "Melihat PPOE : " + PPOEnama;

                    this.cekKePelanggan(PPOEnama,PPOEProfil, cd);
                    
                } else {
                    
                    //console.log("cocok" + JSON.stringify(data.matchItem));
                    //console.log("tidak" + JSON.stringify(data.unmatchItem));

                    // pasangkeList();
                }

            },
            cekKePelanggan(nama, profil, itemppoe) {

                var ListPelanggan = data.AllPelanggan;

                var isCocok = false;

                if(data.StartPelanggan < data.MaxPelanggan) {

                    var item = ListPelanggan[data.StartPelanggan];

                    let namapelanggan = item.nama;
                    let ppoe = item.ppoe;

                    //Log.e(".javax", StartPelanggan + " -- " + namapelanggan);

                    data.StartPelanggan = data.StartPelanggan + 1;
                    
                    if (nama != ppoe) {
                        // ga cocok

                        isCocok = false;

                        //Log.e(".javax", " 2 LoopPpoe() " + StartPelanggan );

                        this.cekKePelanggan(nama, profil, itemppoe);

                    } else {

                        isCocok = true;

                        //Log.e(".javax", "ELSE 1 LoopPpoe() " );

                        // cocok
                        // RESTART START PELANGGAN
                        data.StartPelanggan = 0;

                        data.matchItem.push(itemppoe);

                        data.StartPPOE = data.StartPPOE + 1;

                        //LoopPpoe();

                        // ULANGI
                        setTimeout(
                            function() {
                                //myFunc("param1", "param2")
                                theGet.LoopPpoe();
                            },
                        80);
                    }

                } else {

                    if(!isCocok) {
                        // ga cocok

                        // Log.e(".javax", "ELSE  " + itemppoe.toString() );

                        data.unmatchItem.push(itemppoe);

                        //checkCariBarang(nama, profil, itemppoe);

                        //Log.e(".javax", "Cek Lagi  " + namapelanggan + " -- " + ppoe);

                    }

                    data.StartPelanggan = 0;

                    data.StartPPOE = data.StartPPOE + 1;

                    // Log.e(".javax", "Cek Lagi  LoopPpoe() " + Start + " - " + isCocok);

                    //LoopPpoe();

                    // ULANGI
                    setTimeout(
                        function() {
                            //myFunc("param1", "param2")
                            theGet.LoopPpoe();
                        },
                    80);

                }

            },
            mikrotikchange() {
                data.MaxPPOE = 0;
                data.MPpoeLoading = false;
                data.MPpoeBtn = true;
            }, 
            getDataMikrotik() {

                console.log(JSON.stringify(data.mikrotikPilih.ip))

                var ip = data.mikrotikPilih.ip;
                var via = data.mikrotikPilih.via;
                var username = data.mikrotikPilih.username;
                var password = data.mikrotikPilih.password;

                var datax = {
                    ip: ip,
                    username:username,
                    password:password,
                    via:via
                }
                    
                var apiUrl = "ppoe/list.php";
                myGlobal.callMikrotik(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));

                    if (x.status == true) {
                        var datac = x.data;

                        data.AllPPOE = datac;

                        data.MPpoeLoading = false;

                        data.MaxPPOE = x.pesan;
                        
                    } else {

                    }

                })

            },
            getMikrotik() {
                // for filter
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken')
                }
                
                var apiUrl = inter.MiktorikList();
                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    
                    if (x.status) {
                        data.mikrotik = x.data;
                    } else {
                        //alert(x.pesan);
                    }
                })
            },
            getAllPelanggan() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('myToken')
                }
                
                var apiUrl = inter.AllPelangganForMikrotik();
                myGlobal.call(datax,apiUrl).then(x => {

                    // console.log(JSON.stringify(x));

                    if (x.status) {

                        var datac = x.data;

                        data.AllPelanggan = datac;

                        data.MaxPelanggan = x.pesan;

                    }

                })
            }
        }
        return {
            data, 
            theGet
        }

    },
    mounted () {
        document.title = "Cek PPOE";

        this.theGet.getMikrotik();
        this.theGet.getAllPelanggan();

        //sessionStorage.removeItem('VoucherNama');
    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/mikrotik/cek-ppoe.vue